import * as React from 'react';
import { Carousel } from '../Carousel';
import { IImageInfo } from '../../types/newbuilding';
import { ISlideProps } from '../Carousel/Carousel';
import { Image } from '../Image';
import { CarouselBlock } from '../CarouselBlock';
import { Thumbnails } from '../Thumbnails';

interface IPromoSnippetCarouselProps {
  features: React.ReactNode;
  title: string;
  images: Pick<IImageInfo, 'thumbnailUrl' | 'fullUrl' | 'isDefault'>[];
  labels: React.ReactNode;
  url: string;
}

export function PromoSnippetCarousel({ features, images, title, labels, url }: IPromoSnippetCarouselProps) {
  /**
   * Карусель открывается на слайде с главным фото (`isDefault`), а не на нулевом.
   * Именно этот слайд виден на первом экране и чаще всего становится LCP, поэтому только он
   * рендерится в SSR без lazy и с высоким приоритетом загрузки; остальные — lazy на клиенте.
   * Если lazy сделать нулевой слайд, при главном фото не на первом месте видимый слайд
   * появится только после гидрации, и LCP уедет на ~2 с (см. PERFORMANCE_LCP.MD).
   */
  const defaultSlideIndex = Math.max(
    0,
    images.findIndex((img: IImageInfo) => img.isDefault),
  );

  return (
    <CarouselBlock
      isPromo={true}
      features={features}
      labels={labels}
      thumbnails={<Thumbnails images={images} />}
      url={url}
    >
      <Carousel
        isPromo={true}
        hasThumbnails={images.length > 3}
        slides={images.map(
          (img: IImageInfo, index: number) =>
            ({ visible }: ISlideProps) =>
              visible && (
                <Image
                  alt={`${index + 1}-я Фотография ${title}`}
                  src={img.thumbnailUrl || img.fullUrl}
                  objectFit="cover"
                  lazy={index !== defaultSlideIndex}
                  fetchPriority={index === defaultSlideIndex ? 'high' : undefined}
                />
              ),
        )}
        defaultSlideIndex={defaultSlideIndex}
      />
    </CarouselBlock>
  );
}
